import { isBrowser } from '@common/utils/is-browser'
import Posthog from 'posthog-js'

const POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_API_KEY

if (POSTHOG_API_KEY && process.env.NEXT_PUBLIC_POSTHOG_ENABLED === 'true') {
  if (isBrowser()) {
    Posthog.init(POSTHOG_API_KEY)
  }
}

export default Posthog
